/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import {
  ItemSpecMercuryWidget,
  IItemSpecMercuryProps,
} from '@vlinder-web/item-spec-mercury-widget-react';

export const Preview = (props: IItemSpecMercuryProps) => {
  return (
    <>
      <ItemSpecMercuryWidget {...props} />
    </>
  );
};
Preview.defaultProps = {};
